import { INTEGRATION_STATUS, INTEGRATIONS_INFO, CODE_CONNECT_INTEGRATIONS } from '../../constants';

import html from './integrationEntry.html';

import './style.less';

class IntegrationEntryController {
  constructor(
    IntegrationService,
    IntegrationParametersModal,
    Authentication,
    ConnectCodeModal,
    dateFilter
  ) {
    'ngInject';

    Object.assign(this, {
      IntegrationService,
      IntegrationParametersModal,
      Authentication,
      ConnectCodeModal,
      dateFilter,
    });
  }

  async connect(integration) {
    if (Object.keys(CODE_CONNECT_INTEGRATIONS).includes(integration.type)) {
      this.ConnectCodeModal.open(integration);
      return;
    }

    const parameters = integration.parameters?.length
      ? await this.IntegrationParametersModal.open(integration)
      : null;

    this.processing = true;

    if (parameters) {
      await this.IntegrationService.setParameters(integration, parameters);
    }

    return this.IntegrationService.connect(integration);
  }

  async disconnect() {
    this._process(this.IntegrationService.disconnect);
  }

  toggleDetails() {
    this.detailsVisible = !this.detailsVisible;
  }

  $onInit() {
    const externalSlug = this.integration.parameters.find(
      (param) => param.name === 'external_slug'
    );
    if (externalSlug) {
      this.tooltip = externalSlug.value + externalSlug.postfix;
    }

    if (this.install) {
      this.connect(this.integration);
    }

    this.entryDetails = this.IntegrationService.getIntegrationDetails(this.integration.type);
    this.hasExportDetails = this.entryDetails?.some((e) => e.type === 'export');
    this.detailsVisible = false;
    this.setLastSync();
  }

  $onChanges() {
    this.integration.connected = this.integration.status === INTEGRATION_STATUS.ENABLED;
    this.integration.canDisconnect =
      this.integration.enabled &&
      [
        INTEGRATION_STATUS.ENABLED,
        INTEGRATION_STATUS.ERROR,
        INTEGRATION_STATUS.ERROR_OAUTH,
        INTEGRATION_STATUS.ERROR_BILLING,
      ].includes(this.integration.status);
    this.statusLabel =
      this.integration.status === INTEGRATION_STATUS.ERROR
        ? 'MAINTENANCE'
        : this.integration.status;
    this.setLastSync();
  }

  setLastSync() {
    if (
      this.integration.enabled &&
      this.integration.lastQueued &&
      INTEGRATIONS_INFO[this.integration.type]?.displayLastSync
    ) {
      const date = this.dateFilter(this.integration.lastQueued, 'dd MMM');
      const time = this.dateFilter(this.integration.lastQueued, 'HH:mm');
      this.lastSync = `${date} • ${time}`;
    }
  }

  async _process(fn) {
    this.processing = true;
    await fn(this.integration);
    this.processing = false;
  }
}

export default {
  templateUrl: html,
  controller: IntegrationEntryController,
  controllerAs: 'ctrl',
  bindings: {
    integration: '<',
    install: '<',
    teaser: '<?',
  },
};
